<template>
    <div class="counter-buttons">
        <v-btn
            v-if="suffix"
            size="x-large"
            height="63px"
            :disabled="disabled"
            data-id="update-cars-left-behind"
            class="cars-behind"
            @click="updateValue(count + 1)"
        >
            <span>{{ count }}</span>
            <rider-icon :text="iconText">
                {{ icon }}
            </rider-icon>
            <span class="pl-4">{{ suffix }}</span>
        </v-btn>
        <v-btn
            v-else
            size="x-large"
            height="63px"
            :disabled="disabled"
            :data-id="`update-count-${riderType}`"
            :class="{ car: isCarType }"
            @click="updateValue(count + 1)"
        >
            <span>{{ count }}</span>
            <rider-icon :text="iconText">
                {{ icon }}
            </rider-icon>
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
import { RiderTypes } from '@/features/shared/models/RiderType';
import RiderIcon from '@/features/shared/RiderIcon.vue';
import { ref, computed, watch } from 'vue';
import { getIcon, getIconText } from '@/helpers/IconHelpers';

const props = withDefaults(
    defineProps<{
        count: number;
        riderType: string;
        editMode: boolean;
        suffix?: string;
        disabled: boolean;
    }>(),
    {
        count: 0,
        riderType: RiderTypes.Passengers,
        editMode: false,
        disabled: false
    }
);

const emit = defineEmits(['input']);

const model = ref('');

model.value = String(props.count);

const isCarType = computed(() => {
    return props.riderType === RiderTypes.Cars;
});

const icon = computed(() => {
    return getIcon(props.riderType);
});

const iconText = computed(() => {
    return getIconText(props.riderType);
});

function updateValue(value: string | number) {
    emit('input', Number(value));
}

watch(
    () => props.count,
    (value: number) => {
        model.value = String(value);
    }
);
</script>

<style lang="scss" scoped>
.counter-buttons {
    display: inline-flex;
    padding: 4px;
    flex: 1;
    min-width: 30%;

    .v-btn {
        width: 100%;
    }
}
</style>

<style lang="scss">
.counter-buttons {
    .v-btn__content {
        flex-direction: column;
    }

    &.cars-behind {
        width: 100%;
        margin-bottom: 6px;

        .v-btn {
            text-transform: none;
        }

        .v-btn__content {
            flex-direction: row;
        }
    }

    .v-btn .v-icon {
        --v-icon-size-multiplier: 1;
    }

    .rider-icon {
        .rider-icon__text {
            top: 3px;
            left: 2px;
            letter-spacing: 0;
        }
    }
}

.counter-buttons {
    .v-btn--disabled.v-btn--variant-elevated {
        opacity: 0.4;
    }
}

.car {
    .rider-icon {
        .rider-icon__text {
            left: 5px;
            top: 4px;

            &::after {
                content: '';
                position: absolute;
                display: inline-block;
                background-color: #000000;
                height: 9px;
                width: 15px;
                left: 1px;
                top: 2px;
                z-index: -1;
            }
        }
    }
}
</style>
@/features/shared/models/RiderType
